module.exports = __webpack_public_path__ + "static/media/art-lives-here.16b6a02b.svg";